import React from "react";
import { Card, Row, Stack } from "react-bootstrap";
import styled from "styled-components";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material/SvgIcon/SvgIcon";
import IconContainer from "../../organisms/IconContainer";
import { useNavigate } from "react-router-dom";

export interface ServicioCardProps {
  titulo: string;
  ruta: string;
  Icono: OverridableComponent<SvgIconTypeMap> & { muiName: string };
  tamanoFuenteTitulo?: number;
}

function ServicioCard({
  titulo,
  ruta,
  Icono,
  tamanoFuenteTitulo,
}: ServicioCardProps) {
  const navigate = useNavigate();

  const onCardClick = () => {
    navigate(ruta);
  };

  return (
    <StyledCard onClick={onCardClick}>
      <StyledCardHeader>
        <IconContainer className="pt-2">
          <Icono sx={{ fontSize: 75 }} />
        </IconContainer>
      </StyledCardHeader>
      <Card.Body>
        <Stack className="text-center">
          <StyledTitleRow className="mx-auto mb-2">
            <CardTitle fontSize={tamanoFuenteTitulo}>{titulo}</CardTitle>
          </StyledTitleRow>
        </Stack>
      </Card.Body>
    </StyledCard>
  );
}

const StyledCard = styled(Card)`
  height: 100%;
  cursor: pointer;
  &:hover {
    color: #333;
    background-color: ${(props) => props.theme.colors.light};
  }
`;

const StyledTitleRow = styled(Row)`
  height: 20%;
  width: 100%;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

const CardTitle = styled("h4")<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "20px")};
  font-weight: 500;
  color: #454545;
  text-transform: capitalize;
  letter-spacing: 0.05em;
`;

export default ServicioCard;
